export default __webpack_public_path__ + "static/media/bi_logo.eec7cf0c.png";